import { FormContext, FormErrorTypes } from 'dash-ui';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { isPasswordValid } from 'dash-common';

import { FormFields } from 'pages/ProfilePage/components/ProfileSettings/components/UpdatePasswordForm/constants/constants';

const useValidation = () => {
  const { errorHandlers, formState } = useContext(FormContext);
  const { t } = useTranslation(['forms', 'common', 'pages']);

  return (fieldName: FormFields, value: string) => {
    const setInvalid = (message: string, values?: Record<string, string>) => {
      errorHandlers[fieldName]({
        type: FormErrorTypes.Invalid,
        // @ts-ignore
        message: t(message, values),
      });
    };

    if (!value) {
      setInvalid('forms:messages:fieldIsRequired', {
        fieldName: t(`forms:labels:${fieldName}`),
      });
      return false;
    }

    // check specific fields type
    switch (fieldName) {
      case FormFields.Password:
      case FormFields.NewPassword: {
        if (!isPasswordValid(value)) {
          setInvalid('forms:messages:passwordInvalid');
          return false;
        }
        break;
      }
      case FormFields.ConfirmPassword: {
        if (formState.newPassword !== value) {
          setInvalid('forms:messages:confirmPasswordInValid');
          return false;
        }
        break;
      }
    }
    errorHandlers[fieldName](null);
    return true;
  };
};

export default useValidation;
